import PayOverTimeStatementPdfScreen from 'features/payOverTime/screens/PayOverTimeStatements/PayOverTimeStatementPdfScreen';

export default function PayOverTimeStatementPdfPage() {
  return <PayOverTimeStatementPdfScreen />;
}
